import Gleap from "gleap";

let initialized = false;

/**
 * Manually open the Gleap chat (Kai) from anywhere in the app.
 * Lazy-initializes Gleap on first call. Removes the body class that
 * normally hides the bubble on disabled routes so the chat panel shows.
 */
export function openKaiChat() {
  const key = process.env.REACT_APP_GLEAP_KEY;
  if (!key) return;
  if (!initialized) {
    Gleap.initialize(key);
    initialized = true;
  }
  // Allow Gleap UI to render regardless of current route
  document.body.classList.remove("gleap-disabled-route");
  Gleap.open();
}

export function isGleapInitialized() {
  return initialized;
}

export function markGleapInitialized() {
  initialized = true;
}
